import { StorageAdapter } from '../storage/StorageAdapter'

/**
 * recovery.js — recuperacion de cola al arranque (CAP-06) + lectores de profundidad.
 *
 * Rescata las filas atascadas con el vocabulario de estados (`pending -> in_flight -> done | dead`).
 * NO importa el plugin: solo SQL via StorageAdapter (STOR-05). Sin UI, sin arrancar el worker.
 */

/**
 * Resetea TODAS las filas de outbox atascadas en `in_flight` a `pending` al arrancar,
 * dejando la cola completamente re-drenable tras un crash (CAP-06).
 *
 * UNA sola sentencia idempotente. TODAS las filas in_flight son obsoletas al arranque:
 * tras un crash ningun envio sigue vivo y el worker de sync (F3) AUN NO arranca, asi que
 * no hace falta umbral de timestamp — VERIFIED contra la logica v1 (outbox.js:159-166,
 * `where('status').equals('syncing').modify({status:'queued'})`). Re-ejecutarla es un
 * no-op una vez que no quedan filas in_flight.
 *
 * DEBE correr durante el boot ANTES de que arranque el sync-worker de F3 (F2 solo la
 * EXPONE; F3 cablea el worker). Es seguro porque las answers son idempotentes por su
 * UNIQUE y los eventos se deduplican por las marcas de meta (MetaRepository).
 */
export async function recoverInFlight () {
  await StorageAdapter.run(
    "UPDATE outbox SET status='pending' WHERE status='in_flight'",
    [],
    true
  )
}

// ── Lectores de profundidad (F6 los renderiza luego; F2 solo devuelve numeros) ─────
// Lectura defensiva del COUNT: el backend SQLite nativo (@capacitor-community/sqlite) `query` devuelve { values: [{ cnt: n }] };
// se aliasa el conteo como `cnt` en SQL para leerlo limpio sin depender de la clave 'COUNT(*)'.
async function _countByStatus (status) {
  const result = await StorageAdapter.query(
    'SELECT COUNT(*) AS cnt FROM outbox WHERE status=?',
    [status]
  )
  const row = result && result.values && result.values[0]
  return row && typeof row.cnt === 'number' ? row.cnt : Number((row && row.cnt) || 0)
}

/** Nº de filas pendientes (para badges/banner). */
export async function pendingCount () {
  return _countByStatus('pending')
}

/** Nº de filas en vuelo (debe ser 0 tras recoverInFlight al arranque). */
export async function inFlightCount () {
  return _countByStatus('in_flight')
}

/** Nº de filas en dead-letter (fallaron tras todos los reintentos). */
export async function deadCount () {
  return _countByStatus('dead')
}
